// Generates colors deterministically based on string
export const stringToColor = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + (Math.imul(hash, 32) - hash);
    hash = Math.trunc(hash);
  }

  // Use HSL color space for better color distribution
  // Hue: 0-360 (full spectrum)
  // Saturation: 60-79% (vibrant but not too saturated)
  // Lightness: 45-54% (medium brightness for good contrast)
  const hue = Math.abs(hash) % 360;
  const saturation = 60 + (Math.abs(hash) % 20); // 60-79%
  const shiftedHash =
    hash >= 0 ? Math.floor(hash / 256) : Math.ceil(hash / 256) - 1;
  const lightness = 45 + (Math.abs(shiftedHash) % 10); // 45-54%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
